interface Props {
  rank: number
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const SIZES = {
  sm: 'w-7 h-7 text-xs',
  md: 'w-9 h-9 text-sm',
  lg: 'w-12 h-12 text-lg',
}

const MEDAL_EMOJI = {
  sm: 'text-lg',
  md: 'text-2xl',
  lg: 'text-3xl',
}

/**
 * Shared rank-indicator: gold/silver/bronze medals for the podium,
 * a subtle numbered chip for everyone else. Keeps leaderboards
 * looking consistent across WinnersScreen, the hub backlog, etc.
 */
export function RankMedal({ rank, size = 'md', className = '' }: Props) {
  if (rank === 1) return <span className={`${MEDAL_EMOJI[size]} ${className}`}>🥇</span>
  if (rank === 2) return <span className={`${MEDAL_EMOJI[size]} ${className}`}>🥈</span>
  if (rank === 3) return <span className={`${MEDAL_EMOJI[size]} ${className}`}>🥉</span>

  return (
    <div
      className={`inline-flex items-center justify-center rounded-full
                  font-display font-bold bg-brand-elevated text-brand-muted
                  ${SIZES[size]} ${className}`}
    >
      {rank}
    </div>
  )
}
